"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = require("react");

const isBrowser = () => {
  return Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
};

const useSSR = () => {
  const [browser, setBrowser] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setBrowser(isBrowser());
  }, []);
  return {
    isBrowser: browser,
    isServer: !browser
  };
};

var _default = useSSR;
exports.default = _default;
module.exports = exports.default;